import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const LOGO_DARK_URL = "/images/albmove-logo-dark.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer data-testid="main-footer" className="bg-slate-900 text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-6">
              <img 
                src={LOGO_DARK_URL} 
                alt="AlbMove Logo" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-white text-sm leading-relaxed mb-6">
              Rrjeti më i madh i karikimit elektrik në Shqipëri. 
              Energji e pastër për lëvizshmëri të qëndrueshme.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-lime-400 hover:text-slate-900 flex items-center justify-center transition-all"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-lime-400 hover:text-slate-900 flex items-center justify-center transition-all"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-lime-400 hover:text-slate-900 flex items-center justify-center transition-all"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Lidhje të Shpejta</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Shërbimet
                </Link>
              </li>
              <li>
                <Link to="/stations" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Stacionet e Karikimit
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Rreth Nesh
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Kontakti
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Kushtet & Rregullat
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Shërbimet</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Karikim AC/DC
                </Link>
              </li>
              <li>
                <Link to="/individuals" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Për Individë
                </Link>
              </li>
              <li>
                <Link to="/business" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Zgjidhje për Biznese
                </Link>
              </li>
              <li>
                <Link to="/biznese/flota" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Menaxhim Flotash
                </Link>
              </li>
              <li>
                <Link to="/biznese/mikpritje" className="text-white hover:text-lime-400 transition-colors text-sm">
                  Hotele & Turizëm
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-lime-400 flex-shrink-0 mt-0.5" />
                <span className="text-white text-sm">
                  Rruga Muçaj, Godina 1<br />
                  1032, Vorë, Shqipëri
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-lime-400 flex-shrink-0" />
                <a href="tel:+355682001818" className="text-white hover:text-lime-400 transition-colors text-sm">
                  +355 68 200 1818
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-lime-400 flex-shrink-0 mt-0.5" />
                <div className="flex flex-col">
                  <a href="mailto:info@albmove.al" className="text-white hover:text-lime-400 transition-colors text-sm">
                    info@albmove.al
                  </a>
                  <a href="mailto:support@albmove.al" className="text-white hover:text-lime-400 transition-colors text-sm">
                    support@albmove.al
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-700">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white text-sm text-center md:text-left">
              © {currentYear} AlbMove, C.S.M. Sh.p.k. Të gjitha të drejtat e rezervuara.
            </p>
            <div className="flex flex-col items-center md:items-end gap-2">
              <div className="flex items-center gap-6">
                <Link to="/privacy" className="text-white hover:opacity-80 transition-opacity text-sm">
                  Politika e Privatësisë
                </Link>
                <Link to="/terms" className="text-white hover:opacity-80 transition-opacity text-sm">
                  Kushtet e Përdorimit
                </Link>
              </div>
              <a 
                href="https://enor.al"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="powered-by-enor"
                className="group inline-flex items-center gap-1.5 text-slate-500 hover:text-slate-300 transition-colors"
              >
                <span className="text-[10px] uppercase tracking-wider">Developed by</span>
                <img 
                  src="/images/enor-logo.webp" 
                  alt="ENOR" 
                  className="h-3.5 w-3.5 rounded-sm"
                />
                <span className="text-[11px] font-semibold tracking-wide group-hover:text-slate-200" style={{ color: '#94a3b8' }}>
                  ENOR
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
